import { Product } from "@/types/models/product";
import { ProductFilters } from "@/services/productService";
import { createEntityHook } from "@/hooks/useCrud";
import { productSlice } from "@/store/slices/productNew.slice";

// Create the product hook using the generic CRUD hook
export const useProducts = createEntityHook<Product, ProductFilters>({
  sliceName: "products",
  actions: productSlice.actions,
});

// Export the hook
export default useProducts;
